import { useTranslation } from 'react-i18next';

import type { ChatMessage } from '@/signalr';
import { humanizeDate } from '@ngsos/portal-core/time';
import { TranslatedChatPartComponent } from './TranslatedChatPartComponent';

export type CallerMessageComponentProps = {
  message: ChatMessage;
  translateChat: boolean;
  onImageClick: (url: string) => void;
};

export function CallerMessageComponent({ message, translateChat, onImageClick }: CallerMessageComponentProps) {
  const { i18n } = useTranslation();
  const attachedImageUrl = message.attachedImageUrl;

  return (
    <div className="col-9 p-1 rounded-top-3 rounded-end-3 bg-chat-caller">
      <div className="x-small text-muted">{humanizeDate(message.sentTimeUtc, i18n.language || 'en')}</div>

      {message.message != null && (
        <>
          <div>{message.message}</div>

          <TranslatedChatPartComponent message={message.message} translateChat={translateChat} />
        </>
      )}

      {attachedImageUrl != null && (
        <div className="mt-1 cursor-zoom-in" onClick={() => onImageClick(attachedImageUrl)}>
          <img src={attachedImageUrl} className="img-fluid rounded-3 bg-dark-subtle" alt="Attached image" />
        </div>
      )}
    </div>
  );
}
